import * as React from "react";

const { Consumer, Provider } = React.createContext();

export const ThemeConsumer = Consumer;
export const ThemeProvider = Provider;
